// @flow
import React, { type ElementConfig } from 'react';
import AutoExpandTextarea from 'react-textarea-autosize';
import LabelAndErrorFormGroup, {
  type Props as LabelAndErrorFormGroupProps,
} from '@rover/react-lib/components/utils/LabelAndErrorFormGroup';
import AsInput from '../../../components/utils/AsInput';

const handleKeyPress = (e, onKeyPress) => {
  if (e.key === 'Enter') {
    e.stopPropagation();
  }
  if (onKeyPress) {
    onKeyPress(e);
  }
};

export type Props = $Diff<ElementConfig<typeof AsInput>, { children: * }> & {
  onKeyPress?: Event => void,
  autoExpand?: boolean,
};

const Textarea = ({
  inputRef,
  onChange,
  sensitive,
  className,
  onKeyPress,
  autoExpand,
  ...props
}: Props) => (
  <AsInput {...{ inputRef, onChange, sensitive, className }}>
    {inputProps => {
      const allProps = { ...props, ...inputProps, onKeyPress: e => handleKeyPress(e, onKeyPress) };
      return autoExpand ? <AutoExpandTextarea {...allProps} /> : <textarea {...allProps} />;
    }}
  </AsInput>
);

export default (props: LabelAndErrorFormGroupProps & Props) => (
  <LabelAndErrorFormGroup {...props}>
    {/*  we need to explicitly rename ref back to inputRef here so AsInput can pass it to the actual component  */}
    {({ ref, ...rest }) => <Textarea {...rest} inputRef={ref} />}
  </LabelAndErrorFormGroup>
);
export { Textarea as UnwrappedTextarea };



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/Textarea/Textarea.jsx